import classnames from 'classnames';

import styles from '@components/NavigationTabNew/NavigationTabsNew.module.scss';

import { Tabs } from '@components/Tabs';
import { tabsNavigationStore } from '@common/TabsNavigationPage';
import { translate } from '@chaika/i18n/helper';
import { observer } from 'mobx-react';
import { viewPort } from '@store/ViewPort';

export interface NavigationTabsParams {}

export enum Themes {
    // @ts-ignore
    WHITE = styles.white,
    // @ts-ignore
    GREY = styles.grey,
}

interface NavigationTabsProps extends NavigationTabsParams {
    theme?: Themes;
}

export const NavigationTabNew = observer(({ theme }: NavigationTabsProps) => {
    const {
        navigationTabs: { titleParams = [], activeIndex, onTabClick },
    } = tabsNavigationStore;

    const { isMobileSize } = viewPort;
    const resolvedTheme = theme ?? (isMobileSize ? Themes.WHITE : Themes.GREY);

    return (
        <div className={classnames([styles.root, resolvedTheme])}>
            <div className={styles.tabsWrapper}>
                <Tabs
                    items={titleParams.map((titleParams, index) => ({
                        label: translate(titleParams.title),
                        key: index,
                        dataTest: titleParams.dataTest,
                    }))}
                    dataTest={''}
                    activeIndex={activeIndex}
                    onTabChange={onTabClick}
                />
            </div>
        </div>
    );
});
